import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import Breadcrumb from "../components/site/Breadcrumb";
import CTABand from "../components/site/CTABand";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    setPost(null);
    api.blogPost(slug).then(setPost).catch(() => setPost("error"));
  }, [slug]);

  if (post === "error")
    return (
      <div className="max-w-3xl mx-auto px-5 py-32 text-center">
        <h1 className="font-head text-3xl text-[#0A1C0E]">Post not found</h1>
        <Link to="/blog" className="text-[#1D6B2A] font-semibold mt-4 inline-block">Back to blog</Link>
      </div>
    );
  if (!post) return <div className="py-40 text-center text-[#3A4D3E]">Loading...</div>;

  return (
    <div>
      <article className="max-w-3xl mx-auto px-5 md:px-10 pt-12 pb-16">
        <Breadcrumb items={[{ label: "Blog", to: "/blog" }, { label: post.title }]} />
        <span className="inline-block text-xs font-bold tracking-[0.15em] uppercase text-[#1D6B2A] mt-8">
          {post.category}
        </span>
        <h1 className="font-head text-4xl md:text-5xl font-medium tracking-tight text-[#0A1C0E] mt-3 leading-[1.1]">
          {post.title}
        </h1>
        <p className="text-[#3A4D3E]/80 mt-4">By {post.author}</p>
        <div className="rounded-[1.5rem] overflow-hidden aspect-[16/9] my-9 border border-[#E2E8E4]">
          <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
        </div>
        <div className="prose-cp space-y-5 text-lg text-[#3A4D3E] leading-relaxed">
          {post.content.split("\n\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-[#E2E8E4]">
          <Link to="/blog" className="text-[#1D6B2A] font-semibold">&larr; Back to all posts</Link>
        </div>
      </article>
      <CTABand />
    </div>
  );
}
